<template>
  <div class="signs">
    <span v-if="singList.length > 1">
      Луна в созвездиях {{ singList[0] }} и {{ singList[1] }}
    </span>

    <span v-else>
      Луна в созвездии {{ singList[0] }}
    </span>
  </div>
</template>

<script>
export default {
  name: "MoonSign",
  props: ["signs"],
  data() {
    return {
      singList: [],
    }
  },
  created() {
    this.singList = this.signs.split(";");
  },
  methods: {
    getImage(sign) {
      switch (sign) {
        case "Овен": return "aries.png";
        case "Телец": return "taurus.png";
        case "Близнецы": return "gemini.png";
        case "Рак": return "cancer.png";
        case "Лев": return "leo.png";
        case "Дева": return "virgo.png";
        case "Весы": return "libra.png";
        case "Скорпион": return "scorpius.png";
        case "Стрелец": return "sagittarius.png";
        case "Козерог": return "capricorn.png";
        case "Водолей": return "aquarius.png";
        case "Рыбы": return "pisces.png";
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .sign-icon {
    margin-top: -2px;
    height: 16px;
  }
  .signs {
    font-weight: 600;
  }
</style>